import Providers from "./Providers/Providers"
import MuiThemeProvider from "./Providers/MuiThemeProvider"
import CssBaseline from "@material-ui/core/CssBaseline"
import FullPageError from "../../common/FullPageError"
import { ApolloProvider } from "react-apollo"
import { EventProvider } from "../../context/EventContext"
import { NetworkStatusProvider } from "../../context/NetworkStatusContext"
import { UiProvider } from "../../context/UiContext"
import { AuthInfoProvider } from "../../context/AuthContext"
import MetadataComponentWrapper from "./Providers/MetadataComponentWrapper"
import React from "react"
import { Maybe } from "../../../graphql/generated-types"
import ApolloClient from "apollo-client"
import { NextComponentType, NextPageContext } from "next/dist/shared/lib/utils"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { publicEnvVars } from "../../../utils/config"
import { withRouter } from "next/router"
import { Router as RouterProps } from "next/dist/client/router"

type Props = {
    Component: NextComponentType<NextPageContext>
    pageProps: any
    apolloClient: Maybe<ApolloClient<any>>
    showErrorPage: boolean
    router: RouterProps
}
const MainApp = (props: Props) => {
    const { Component, pageProps, apolloClient, router } = props

    // Todo: this component wrappers-based approach is not very nice. Refactor to hooks.
    if (props.showErrorPage) {
        return (
            <Providers>
                <MuiThemeProvider displayPreloading={true} isThemeWrapper={true}>
                    <CssBaseline />
                    <FullPageError />
                </MuiThemeProvider>
            </Providers>
        )
    }

    return (
        <Providers>
            {!apolloClient ? (
                <MuiThemeProvider displayPreloading={true} isThemeWrapper={true}>
                    <CssBaseline />
                    <Component {...pageProps} displayPreloading={true} />
                </MuiThemeProvider>
            ) : (
                <ApolloProvider client={apolloClient}>
                    <GoogleReCaptchaProvider reCaptchaKey={publicEnvVars.GOOGLE_RECAPTCHA_KEY}>
                        <EventProvider>
                            <NetworkStatusProvider>
                                <UiProvider>
                                    <AuthInfoProvider router={router}>
                                        <MuiThemeProvider isThemeWrapper={true}>
                                            <MetadataComponentWrapper />
                                            <CssBaseline />
                                            <Component {...pageProps} />
                                        </MuiThemeProvider>
                                    </AuthInfoProvider>
                                </UiProvider>
                            </NetworkStatusProvider>
                        </EventProvider>
                    </GoogleReCaptchaProvider>
                </ApolloProvider>
            )}
        </Providers>
    )
}

export default withRouter(MainApp)
